module.exports = __webpack_public_path__ + "static/media/contant-us-1.275d8b76.jpg";